import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsNumber } from 'class-validator';
import { Expose, Transform } from 'class-transformer';
import { ClientType } from '../client/clientType';
import { DealStatus } from '../deal';

export class DealParticipantStatisticsRequest {
  @ApiProperty()
  @Expose()
  @IsNotEmpty()
  @Transform(({ value }) => Number(value))
  status: DealStatus;

  @ApiProperty()
  @Expose()
  @IsNotEmpty()
  @Transform(({ value }) => Number(value))
  participantId: number;

  @ApiProperty()
  @Expose()
  @IsNotEmpty()
  @Transform(({ value }) => Number(value))
  clientType: ClientType;
}

export class DealParticipantStatisticsResponse {
  @ApiProperty({ example: 23 })
  @IsNumber()
  percentage: number;
}
